import React, { useContext } from 'react';
import { Props } from '../MonoView';
import { getImageStylesAndSrc } from './helpers';
import ImgZoomable from './ImageZoomable';
import Img from './ImageBase';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import HiddenDumbView from '../../../DeviationViews/Dumbo/Hidden/Hidden';
import EditorDeviationLink from '../_partials/DeviationLink';
import { SMALL_MEDIA_WIDTH } from '../constants';
import isEmpty from 'lodash/isEmpty';

const ImageView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const { deviation, extOptions, width: propsWidth, link } = props;
  const showMatureContent = useContext(MatureContext);
  const { isLoggedIn } = useContext(SessionContext);

  // Handle small media
  const width = extOptions?.smallMedia ? SMALL_MEDIA_WIDTH : propsWidth;

  if (
    (!showMatureContent && deviation.isMature) ||
    deviation.isBlocked ||
    (deviation.isAntisocial && !isLoggedIn)
  ) {
    // We have extra check for anti-social because inside a saved editor
    // deviation we can have stale isBlocked value
    return <HiddenDumbView {...props} width={width ?? 780} />;
  }

  const calculatedProps = getImageStylesAndSrc(
    deviation,
    width,
    extOptions,
    containerSize
  );

  if (!calculatedProps) {
    return null;
  }

  const { allowFullview, wrapperStyles, coverThumb, imgStyles, canBeLinked } =
    calculatedProps;

  // When link is overridden don't use zoom
  const ImageComponent =
    allowFullview && !canBeLinked && isEmpty(link) ? ImgZoomable : Img;

  return (
    <EditorDeviationLink
      style={wrapperStyles}
      link={link}
      deviation={deviation}
    >
      <ImageComponent
        file={coverThumb}
        deviation={deviation}
        imgStyles={imgStyles}
      />
    </EditorDeviationLink>
  );
};
ImageView.displayName = 'ImageView';

export default ImageView;
